import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import * as styles from '../../styles';
import {request} from '../../containers/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import {refresh as paginatorRefresh, clearSelection} from '../../paginator/actions';
import { setStorePackParentId } from './reducer';
export default class ExaminationStoreItemsPack extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }
    buttonActionsSelector = createSelector(
            [
                () => this.props.buttonActions,
                () => this.props.readonly,
            ],
            () => this.props.readonly
                ? this.props.buttonActions
                : _.concat(this.props.buttonActions, [
                    {
                        label: window.gettext('New sell pack'),
                        action: async () => {
                            this.context.store.dispatch(push('/store/free-items/add/'));
                        },
                    },
                ]),
        )
    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {
            field: item => `${item.title}`,
            label: window.gettext('Title'),
        },
        {
            field: item => ({
                1: window.gettext('Restricted'),
                2: window.gettext('Virtual'),
            })[item.category] 
            , label: window.gettext('Category'),
        },
        {field: 'price', label: window.gettext('Price')},
        {
            field: item => item.off ? <span style={{color: 'red'}}>{'%' + item.off.persian()}</span> : null,
            label: window.gettext('Off'),
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.supply_in_store
                        ? styles.successBackColor
                        : styles.warningBackColor,
                    color: item.supply_in_store
                        ? styles.successColor
                        : styles.warningColor,
                    borderColor: item.supply_in_store
                        ? styles.successBorderColor
                        : styles.warningBorderColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '2em',
                }}
                className={item.supply_in_store ? 'fa-check' : 'fa-times'}>
            </div>,
            label: window.gettext('Supply in store'),
        },
        {field: 'sold', label: window.gettext('Sold')},
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={async event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push('/store/free-items/' + item.id + '/'));
                }}
                onMouseUp={({target}) => target.blur()}>
                {window.gettext('Edit')}
            </button>,
        },
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={async event => {
                    await window.wait(500);
                    const response = await this.context.store.dispatch(request({
                        path : `/store-item/${item.id}/`,
                        method: 'DELETE',
                    }));
                    this.context.store.dispatch([
                        clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                        paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                    ]);
                }}
                onMouseUp={({target}) => target.blur()}>
                {window.gettext('Remove')}
            </button>,
        },
    ]

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true}
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(
                    this.props.actions,
                    [
                        {
                            label: window.gettext('Supply in store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna supply these %(count)s items in store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, 'supply_in_store': true})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Remove from store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s items from store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, 'supply_in_store': false})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                    ],
                )
    )

    componentDidUpdate(prevProps) {
        if (this.props.params?.id) {
            const elementId = this.props.store.getIn(['paginator', 'elementId']);
            this.context.store.dispatch(setStorePackParentId(this.props.params.id, elementId));
        }
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    categoryChanged(category, event) {
        if (event)
            event.stopPropagation();
        let categories = this.props.location.query.category || [];
        if (!(categories instanceof Array))
            categories = [categories];
        categories = _.map(categories, category => Number.parseInt(category));
        if (_.includes(categories, category)) {
            _.remove(categories, s => s === category);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, category: categories},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    category: [...categories, category],
                },
            }));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource={'store-item/' + this.props.params.id + '/packs'}
            title={window.gettext('Examination Packs')}
            listFields={this.listFields}
            readonly
            selectable={false}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            buttonActions={this.buttonActionsSelector(this.props.store)}
            actions={this.actionsSelector(this.props.store)}
        />;
    }
}

